module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.callPhone(4006027009)
      }
    }
  }, [_c('img', {
    staticClass: "tool dh",
    attrs: {
      "src": require("../../assets/dh.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('img', {
    staticClass: "tool kf",
    attrs: {
      "src": require("../../assets/kf.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-692c6e8b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/header/header.vue
// module id = 285
// module chunks = 1